// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file errors.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file errors.proto.
 */
export const file_errors: GenFile = /*@__PURE__*/
  fileDesc("CgxlcnJvcnMucHJvdG8SBmRvbWFpbiJYCgtEb21haW5FcnJvchIMCgRjb2RlGAEgASgFEhIKCnVzZXJfdGl0bGUYAyABKAkSEwoLdXNlcl9kZXRhaWwYBCABKAkSEgoKcmVxdWVzdF9pZBgFIAEoCSJOCgZTdGF0dXMSDAoEY29kZRgBIAEoBRIPCgdtZXNzYWdlGAIgASgJEiUKB2RldGFpbHMYAyADKAsyFC5nb29nbGUucHJvdG9idWYuQW55QjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw", [file_google_protobuf_any]);

/**
 * @generated from message domain.DomainError
 */
export type DomainError = Message<"domain.DomainError"> & {
  /**
   * Code that can be used by the client application to handle this specific type of error.
   * See /backend/domainerr/errors.go for error codes.
   *
   * @generated from field: int32 code = 1;
   */
  code: number;

  /**
   * UserTitle is a user-friendly title of the error.
   * It must not change between occurances of the error (except for localization.)
   * Use UserDetail for instance specific details.
   *
   * @generated from field: string user_title = 3;
   */
  userTitle: string;

  /**
   * UserDetail is a user-friendly error message describing what went wrong.
   * Clients need to escape this string as it might contain user-provided data.
   *
   * @generated from field: string user_detail = 4;
   */
  userDetail: string;

  /**
   * RequestId to identify the erroneous request in the logs.
   *
   * @generated from field: string request_id = 5;
   */
  requestId: string;
};

/**
 * Describes the message domain.DomainError.
 * Use `create(DomainErrorSchema)` to create a new message.
 */
export const DomainErrorSchema: GenMessage<DomainError> = /*@__PURE__*/
  messageDesc(file_errors, 0);

/**
 * The `Status` type defines a logical error model that is suitable for
 * different programming environments, including REST APIs and RPC APIs. It is
 * used by [gRPC](https://github.com/grpc). Each `Status` message contains
 * three pieces of data: error code, error message, and error details.
 *
 * You can find out more about this error model and how to work with it in the
 * [API Design Guide](https://cloud.google.com/apis/design/errors).
 *
 * @generated from message domain.Status
 */
export type Status = Message<"domain.Status"> & {
  /**
   * The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
   *
   * @generated from field: int32 code = 1;
   */
  code: number;

  /**
   * A developer-facing error message, which should be in English. Any
   * user-facing error message should be localized and sent in the
   * [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * A list of messages that carry the error details.  There is a common set of
   * message types for APIs to use.
   *
   * @generated from field: repeated google.protobuf.Any details = 3;
   */
  details: Any[];
};

/**
 * Describes the message domain.Status.
 * Use `create(StatusSchema)` to create a new message.
 */
export const StatusSchema: GenMessage<Status> = /*@__PURE__*/
  messageDesc(file_errors, 1);

